var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{rtl: _vm.$i18n.locale === 'AR'},attrs:{"id":"app"}},[_c('Head'),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.showAccept)?_c('Accept',{on:{"close":function($event){_vm.showAccept = false}}}):_vm._e(),_vm._v(" "),(_vm.alertinfo.showis)?_c('Alert'):_vm._e(),_vm._v(" "),(_vm.showLoading)?_c('Loading'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2616c558","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 